
import React, { useState, useEffect } from "react";
import { CheckCircle } from "lucide-react";
import { 
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { VEHICLE_TYPES } from "../VehicleConstants";

interface VehicleTypeSelectProps {
  value: string;
  onChange: (value: string) => void;
}

const VehicleTypeSelect = ({ value, onChange }: VehicleTypeSelectProps) => {
  const [selected, setSelected] = useState(false);
  
  useEffect(() => {
    setSelected(value !== "");
  }, [value]);
  
  return (
    <div className="space-y-2">
      <label htmlFor="vehicleType" className="block text-sm font-medium text-black">
        Vehicle Type
      </label>
      <div className="relative">
        <Select value={value} onValueChange={(value) => {
          onChange(value);
          setSelected(true);
        }}>
          <SelectTrigger id="vehicleType" className="bg-white text-black border-gray-300">
            <SelectValue placeholder="Select" />
          </SelectTrigger>
          <SelectContent>
            {VEHICLE_TYPES.map(type => (
              <SelectItem key={type.value} value={type.value}>
                {type.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        {selected && (
          <CheckCircle className="absolute right-10 top-1/2 transform -translate-y-1/2 h-5 w-5 text-green-500" />
        )}
      </div>
    </div>
  );
};

export default VehicleTypeSelect;
